export const SMaskedInputOverrides = error => ({
  Root: {
    style: ({ $theme }) => ({
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error ? 'transparent' : $theme.colors.white,
    }),
  },
  Input: {
    style: ({ $theme, $disabled }) => ({
      color: $theme.colors.black,
      fontSize: '16px',
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      paddingBottom: '.125rem',
      borderColor: error ? $theme.colors.errorInput : '',
      backgroundColor: error || $disabled ? 'transparent' : $theme.colors.white,
    }),
  },
  InputContainer: {
    style: {
      paddingTop: '0.625rem',
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      paddingTop: '0.625rem',
      paddingLeft: '0',
      paddingRight: '0',
      paddingBottom: '0',
      backgroundColor: error ? 'transparent' : '',
    },
  },
})
